<template>
  <div>
    <h1>Finance</h1>
    <v-row justify="space-around">
      <v-col cols="12" sm="6" md="2">
        <v-card elevation="1" color="secondary lighten-3">
          <v-card-text class="text-center py-10 font-weight-bold">
            <span class="figures-big">1</span> EUR = <span class="figures-big">{{lastRates.eur}}</span> USD
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="2">
        <v-card elevation="1" color="primary lighten-3">
          <v-card-text class="text-center py-10 font-weight-bold">
            <span class="figures-big">1</span> BRL = <span class="figures-big">{{lastRates.brl}}</span> USD
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="2">
        <v-card elevation="1" color="accent lighten-1">
          <v-card-text class="text-center py-10 font-weight-bold">
            <span class="figures-big">1</span> GBP = <span class="figures-big">{{lastRates.gbp}}</span> USD
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row justify="start">
      <v-col cols="2">
            <ModalFinance @save="saveRates" :rates="lastRates" v-if="isDataReady"/>
      </v-col>
      <v-col cols="12">
        <v-card>
          <v-card-text>
            <apexchart type="line" height="300px" :options="chartOptions" :series="series"></apexchart>
          </v-card-text>
        </v-card>
      </v-col>

    </v-row>
  </div>

</template>

<script>
import MainLayout from "../../layouts/MainLayout"
import ModalFinance from "../../common/ModalFinance"
import rateApi from '../../../api/rateApi';

export default {
  data() {
    return {
      chartOptions: {
        chart: {
          id: 'vuechart-example',
          toolbar: {
            tools: {
              download: false,
              selection: false,
              zoom: false,
              zoomin: false,
              zoomout: false,
              pan: false,
              reset: false
            }
          },
        },
        xaxis: {
          categories: ['', '']
        },
        colors: ['var(--v-primary-lighten3)', 'var(--v-secondary-lighten3)', 'var(--v-accent-lighten1)'],
      },
      series: [
        {
          name: 'BRL',
          data: [0, 0]
        },
        {
          name: 'EUR',
          data: [0, 0]
        },
        {
          name: 'GBP',
          data: [0, 0]
        }
      ],
      isDataReady: false,
      lastRates: {
        eur: 0,
        brl: 0,
        gbp: 0
      },
      eurRates: [],
      brlRates: [],
      gbpRates: [],
      dates: []
    }
  },
  async mounted() {
    await this.fetchRates();
  },

  methods: {
    saveRates: async function(data) {
      const preparedData = [
        {currency_id_from: 2, rate: data['EUR']},
        {currency_id_from: 3, rate: data['BRL']},
        {currency_id_from: 4, rate: data['GBP']},
      ];
      await rateApi.createRates(preparedData);
      await this.fetchRates();
    },

    compareByDates: (a, b) => (a.dateAdded > b.dateAdded) ? 1 : ((b.dateAdded > a.dateAdded) ? -1 : 0),

    fetchRates: async function () {
      const rates = await rateApi.getRates();
      if (!rates.length) {
        this.isDataReady = true;
        return;
      }
      this.eurRates = rates.filter(rate => rate.id === 2);
      this.brlRates = rates.filter(rate => rate.id === 3);
      this.gbpRates = rates.filter(rate => rate.id === 4);

      this.eurRates= this.eurRates.sort(this.compareByDates);
      this.brlRates = this.brlRates.sort(this.compareByDates);
      this.gbpRates = this.gbpRates.sort(this.compareByDates);

      this.lastRates.eur = this.eurRates[this.eurRates.length - 1].rate;
      this.lastRates.brl = this.brlRates[this.brlRates.length - 1].rate;
      this.lastRates.gbp = this.gbpRates[this.gbpRates.length - 1].rate;

      this.dates = this.eurRates.map(rate => (new Date(+rate.dateAdded)).toISOString().slice(0,10));

      console.log(this.dates);

      this.series =  [
        {name: 'BRL', data: this.brlRates.map(r => r.rate)},
        {name: 'EUR', data: this.eurRates.map(r => r.rate)},
        {name: 'GBP', data: this.gbpRates.map(r => r.rate)}
      ];

      this.chartOptions = {...this.chartOptions, xaxis: {categories: this.dates}};

      this.isDataReady = true;

    }
  },


  components: {
    MainLayout,
    ModalFinance
  },

}
</script>

<style scoped lang="sass">
  .figures-big
    font-size: 1.8rem
    font-weight: bold
</style>
